export default "__VITE_ASSET__xe48zUz3__"